module.exports = __webpack_public_path__ + "2d7056b4ad9513f66832b6d9dcf528c2.png";